"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsDocGrid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRouterDom = require("react-router-dom");
var _useGetFilesFromChannel = require("@/api/useGetFilesFromChannel");
var _DocumentIcon = require("@/components/DocumentManagementView/DocumentGrid/DocumentIcon");
var _CustomGrid = _interopRequireDefault(require("@/components/shared/CustomGrid/CustomGrid"));
var _SearchField = _interopRequireDefault(require("@/components/shared/SearchField/SearchField"));
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
var _useExploreFolder2 = require("@/hooks/useExploreFolder");
var _useTeamsFiles2 = require("@/hooks/useTeamsFiles");
var _DocumentGridBreadcrumb = _interopRequireDefault(require("@/pages/DocumentManagementView/DocumentGridBreadcrumb"));
var _constants = require("@/util/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TeamsDocGrid = exports.TeamsDocGrid = function TeamsDocGrid(_ref) {
  var _selectedChannel$driv;
  var selectedChannel = _ref.selectedChannel,
    onLoadingChange = _ref.onLoadingChange;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPath = _useState2[0],
    setSelectedPath = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPathIds = _useState4[0],
    setSelectedPathIds = _useState4[1];
  var _useState5 = (0, _react.useState)(selectedChannel ? selectedChannel.item_id : ""),
    _useState6 = _slicedToArray(_useState5, 2),
    parentId = _useState6[0],
    setParentId = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = _slicedToArray(_useState7, 2),
    searchText = _useState8[0],
    setSearchText = _useState8[1];
  var theme = (0, _material.useTheme)();
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    msalConfig = _useTeamsAndChannels.msalConfig;
  var _useTeamsFiles = (0, _useTeamsFiles2.useTeamsFiles)(),
    addTeamsFiles = _useTeamsFiles.addTeamsFiles,
    getTeamsFilesByParentId = _useTeamsFiles.getTeamsFilesByParentId,
    selectedRows = _useTeamsFiles.selectedRows,
    setSelectedRows = _useTeamsFiles.setSelectedRows,
    updateTeamsFile = _useTeamsFiles.updateTeamsFile,
    teamsFiles = _useTeamsFiles.teamsFiles,
    getSelectedFiles = _useTeamsFiles.getSelectedFiles;
  var _useExploreFolder = (0, _useExploreFolder2.useExploreFolder)(),
    exploreFolderInBackground = _useExploreFolder.exploreFolderInBackground,
    isExploringFolders = _useExploreFolder.isLoading;
  var _useGetFilesFromChann = (0, _useGetFilesFromChannel.useGetFilesFromChannel)({
      drive_id: (_selectedChannel$driv = selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.drive_id) !== null && _selectedChannel$driv !== void 0 ? _selectedChannel$driv : "",
      item_id: parentId
    }, msalConfig.backend_uri),
    files = _useGetFilesFromChann.data,
    isLoading = _useGetFilesFromChann.isLoading;
  var gridRef = (0, _react.useRef)(null);
  // Get grid rows using the custom hook
  var allGridRows = getTeamsFilesByParentId(parentId);

  // Apply search filter if there's search text
  var gridRows = searchText ? allGridRows.filter(function (file) {
    return file.name.toLowerCase().includes(searchText.toLowerCase());
  }) : allGridRows;
  (0, _react.useEffect)(function () {
    if (selectedChannel) {
      setParentId(selectedChannel.item_id);
      setSelectedPath([]);
      setSelectedPathIds([]);
    }
  }, [selectedChannel]);
  (0, _react.useEffect)(function () {
    if (files && files.length > 0 && selectedChannel) {
      addTeamsFiles(files.map(function (f) {
        return _objectSpread(_objectSpread({}, f), {}, {
          channel: _objectSpread({}, selectedChannel)
        });
      }));

      // Mark the parentId as explored
      if (parentId) {
        updateTeamsFile(parentId, {
          explored: true
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files, parentId, selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.item_id, selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.drive_id, selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.channelName, selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.teamName]);
  (0, _react.useEffect)(function () {
    if (selectedPath.length === 0) {
      setParentId(selectedChannel ? selectedChannel.item_id : "");
      setSelectedPathIds([]);
    } else {
      var pathLength = selectedPath.length;
      setParentId(selectedPathIds[pathLength - 1]);
      setSelectedPathIds(selectedPathIds.slice(0, pathLength));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPath]);

  // Auto-select children when new files are loaded for selected folders
  // Note: This logic is now mostly handled by SimpleGrid's hierarchical selection,
  // but we keep this to ensure folder exploration happens when needed
  (0, _react.useEffect)(function () {
    if (selectedRows.length === 0 || teamsFiles.length === 0) return;

    // Check each selected row to see if it's a folder that needs exploration
    var _iterator = _createForOfIteratorHelper(selectedRows),
      _step;
    try {
      var _loop = function _loop() {
        var selectedId = _step.value;
        var selectedFile = teamsFiles.find(function (f) {
          return f.id === selectedId;
        });
        if (selectedFile !== null && selectedFile !== void 0 && selectedFile.folder && !selectedFile.explored && selectedChannel) {
          exploreFolderInBackground(selectedFile, selectedChannel);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [teamsFiles.length]); // Trigger when teamsFiles count changes

  // Update submit button state when folder exploration status changes
  (0, _react.useEffect)(function () {
    onLoadingChange(isExploringFolders);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExploringFolders]);
  var handleColumnNameClick = function handleColumnNameClick(teamsFile) {
    if (teamsFile.folder) {
      setParentId(teamsFile.id);
      setSelectedPathIds([].concat(_toConsumableArray(selectedPathIds), [teamsFile.id]));
      setSelectedPath([].concat(_toConsumableArray(selectedPath), [{
        id: teamsFile.id,
        name: teamsFile.name
      }]));
    }
  };
  var columns = [{
    field: "name",
    headerName: "Document Name",
    renderCell: function renderCell(params) {
      var itemType = params.row.folder ? _constants.TYPE_FOLDER : _constants.TYPE_FILE;
      return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: params ? params.row.name : null,
        arrow: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "flex align-items-center gap-8"
      }, /*#__PURE__*/_react["default"].createElement(_DocumentIcon.DocumentIcon, {
        fileType: itemType
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        style: {
          color: itemType === _constants.TYPE_FOLDER ? theme.palette.primary.main : "#515152",
          textDecoration: "none",
          maxWidth: "80%",
          cursor: itemType === _constants.TYPE_FOLDER ? "pointer" : "default"
        },
        "data-testid": "link-".concat(params.row.name),
        className: "text-overflow-ellipsis",
        to: "/document-viewer?id=".concat(params.row.id),
        onClick: function onClick(e) {
          e.preventDefault();
          handleColumnNameClick(params.row);
        },
        target: "_blank"
      }, params.row.name)));
    },
    flex: 1
  }, {
    field: "lastModifiedDateTime",
    headerName: "Modified",
    flex: 1
  }, {
    field: "lastModifiedBy",
    headerName: "Modified by",
    renderCell: function renderCell(params) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, params.row.lastModifiedBy.user.displayName);
    },
    flex: 1
  }];

  // Handle folder exploration when a folder is selected
  var handleFolderSelection = function handleFolderSelection(file) {
    if (file.folder && selectedChannel && !file.explored) {
      exploreFolderInBackground(file, selectedChannel);
    }
  };

  // Function to handle selection changes from SimpleGrid
  var handleCustomGridSelectionChange = function handleCustomGridSelectionChange(selectedRowsFromGrid) {
    // Handle folder exploration for newly selected folders
    var _iterator2 = _createForOfIteratorHelper(selectedRowsFromGrid),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var file = _step2.value;
        if (file.folder && !selectedRows.includes(file.id)) {
          handleFolderSelection(file);
        }
      }

      // Update the Teams file selection state with the new selection
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    setSelectedRows(selectedRowsFromGrid.map(function (row) {
      return row.id;
    }));
  };
  var selectedFiles = getSelectedFiles().filter(function (f) {
    return !f.folder;
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex gap-8 align-items-center grid-header",
    height: "68px"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between width-100"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    maxWidth: "250px"
  }, /*#__PURE__*/_react["default"].createElement(_SearchField["default"], {
    searchText: searchText,
    setSearchText: setSearchText,
    placeholder: "Search by Document Name"
  })), selectedFiles.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      padding: "0 10px",
      gap: "5px"
    }
  }, isExploringFolders && /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 12
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "Selected files: "))), /*#__PURE__*/_react["default"].createElement("span", null, " ", selectedFiles.length, " (", Number(selectedFiles.reduce(function (acum, f) {
    return acum + f.size;
  }, 0) / 1024 / 1024).toFixed(2), " ", "MB)")))), /*#__PURE__*/_react["default"].createElement(_DocumentGridBreadcrumb["default"], {
    rootText: selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.channelName,
    breadcrumbs: selectedPath,
    clickOnPathCallback: setSelectedPath
  }), /*#__PURE__*/_react["default"].createElement(_CustomGrid["default"], {
    ref: gridRef,
    style: {
      height: "calc(100% - 68px - 35px)",
      maxHeight: "calc(100% - 68px - 35px)",
      overflow: "visible"
    },
    loading: isLoading,
    rows: gridRows,
    columns: columns,
    checkboxSelection: true,
    keepNonExistentRowsSelected: true,
    allRows: teamsFiles,
    initialSelectedRowIds: selectedRows,
    onSelectionChange: handleCustomGridSelectionChange,
    pageSizeOptions: [5, 10, 50, 100],
    disableRowSelectionOnClick: true,
    classes: {
      footerContainer: "footer"
    }
  }));
};